import api from '../configs/api.config';
import { WEFResponse } from '../Types';
import { ClientSearchDropdownkResponseType } from '../schemas/client.schema';
import {
  ClientOption,
  PlateTransferEligibility,
  PlateTransferResult,
  TransferPlateRequest
} from '../types/plateTransfer.types';

export const getPlateTransferEligibility = async (plateId: string) => {
  const { data } = await api.get<WEFResponse<PlateTransferEligibility>>(
    `/Plate/${plateId}/transfer-eligibility`,
    { silent: true }
  );
  return data?.data;
};

export const transferPlate = async (plateId: string, request: TransferPlateRequest) => {
  const { data } = await api.post<WEFResponse<PlateTransferResult>>(
    `/Plate/${plateId}/transfer`,
    request,
    { silent: true }
  );
  return data?.data;
};

/** Client name search for the transfer picker. Silent so typing doesn't raise a toast per search. */
export const searchClientsForTransfer = async (searchTerm: string): Promise<ClientOption[]> => {
  const { data } = await api.get<ClientSearchDropdownkResponseType>('/Client/search', {
    params: { 'search-term': searchTerm },
    silent: true
  });
  return (data?.data ?? [])
    .filter((client) => !!client)
    .map((client) => ({ value: client.id, label: client.name }));
};
